import { BackButton, FilteredCreditApplication, Loader } from '@applyonline/shared'
import { formatCurrency } from '@if/core/utils'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useTermPaymentsTable from '../../../../containers/InitialApprobationPage/hooks'
import { applicantFullName } from '../../../../data/creditapp-selectors'

interface Props {
  creditApp: FilteredCreditApplication
}

const CreditSummaryPage = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [monthlyPaymentPerMonths, isLoadingTerms] = useTermPaymentsTable(creditApp)
  const minTermPayment = useMemo(
    () => (monthlyPaymentPerMonths ? monthlyPaymentPerMonths[monthlyPaymentPerMonths.length - 1] : null),
    [monthlyPaymentPerMonths],
  )
  const maxTermPayment = useMemo(
    () => (monthlyPaymentPerMonths ? monthlyPaymentPerMonths[0] : null),
    [monthlyPaymentPerMonths],
  )

  if (isLoadingTerms) return <Loader description="" />
  return (
    <main className="form-section">
      <div className="credit-steps">
        <div className="applicationInfo-card paragraph">
          <h3>{t('common.appNumber', { number: creditApp.referenceNumber })}</h3>
          <div>
            <p className="applicationInfo-card-subtitle">
              <strong>{t('common.applicant')} : </strong>
              {applicantFullName(creditApp.applicant)}
            </p>
          </div>
        </div>
        <div className="applicationInfo-card paragraph">
          <h3>{t('loan.details')}</h3>
          <div>
            <p>
              <strong>{t('common.maxLoanAmount')} : </strong>
              {formatCurrency(creditApp.finalDecision.maxAmountFinanced)}
            </p>
            <p>
              <strong>{t('common.requestedAmount')} : </strong>
              {formatCurrency(creditApp.worksheet?.amountRequested)}
            </p>
            <p>
              <strong>{t('common.monthlyPaymentMin')} : </strong>
              {minTermPayment
                ? t('loan.monthPeriodItem', {
                    loanTerm: minTermPayment.term,
                    loanAmount: formatCurrency(minTermPayment.amountWithoutInsurance),
                  })
                : t('common.n/a', { ns: 'shared' })}
            </p>
            <p>
              <strong>{t('common.monthlyPaymentMax')} : </strong>
              {maxTermPayment
                ? t('loan.monthPeriodItem', {
                    loanTerm: maxTermPayment.term,
                    loanAmount: formatCurrency(maxTermPayment.amountWithoutInsurance),
                  })
                : t('common.n/a', { ns: 'shared' })}
            </p>
            <p>
              {t('common.monthlyAmountsInclude', {
                financeFee: creditApp?.normsDecision.lenderFeeRate,
                interestRate: creditApp?.finalDecision.interestRate,
              })}
            </p>
          </div>
        </div>{' '}
      </div>
      <BackButton />
    </main>
  )
}

export default CreditSummaryPage
